/* eslint-disable no-undef */
/* eslint-disable jquery/no-class */
/* eslint-disable jquery/no-html */
/* eslint-disable jquery/no-find */
/* eslint-disable jquery/no-text */
/* eslint-disable jquery/no-ajax */
import throttle from './throttle';
import { initSearchIconClick, getPageOffset, isKeyboardOpen } from './header';

const SCROLL_INTERVAL = 150;

/**
 * Initialise mobile search behaviour on the header
 */
const initMobileSearch = () => {
  const header = document.querySelector('.header-sticky');
  const searchIconElement = document.querySelector('.header-element__search[data-toggle="search-mobile"]');
  const isHomePage = document.querySelector('.page[data-action="Home-Show"]');
  const isPDP = document.body.classList.contains('new-pdp');
  const storeIcon = document.querySelector('.header-element.stores.left');
  const accountIcon = document.querySelector('.header-element__user.left');
  const searchRight = document.querySelector('.header-item__search.right');
  const logoLeft = document.querySelector('.header-element.logo.left');
  const logoCenter = document.querySelector('.header-element.logo.center');
  const primaryCategory = document.querySelector('.primary-category-slider');

  const isMobile = window.innerWidth <= 767;
  const isTablet = window.innerWidth > 767 && window.innerWidth <= 1023;

  if (!header || !searchIconElement) {
    return;
  }

  const setInitialState = () => {
    if (isHomePage || isPDP) {
      searchIconElement.classList.add('d-none');
    } else {
      searchIconElement.classList.add('d-block');
    }
    if (storeIcon) storeIcon.classList.add('d-none');
    if (accountIcon) accountIcon.classList.add('d-none');
  };

  setInitialState();
  const setDisplay = (el, value) => {
    if (el && el.style.display !== value) {
      el.style.cssText = `display: ${value} !important`;
    }
  };
  // Toggle search icon and other icons based on scroll position (after header-banner)
  window.addEventListener('scroll', throttle(() => {
    if (isKeyboardOpen()) return;
    const yOffset = window.pageYOffset;
    const PAGE_OFFSET = getPageOffset();

    // Show/hide main search icon
    if (yOffset < PAGE_OFFSET && !isHomePage && !isPDP) {
      searchIconElement.classList.add('d-block');
      searchIconElement.classList.remove('d-none');
      if (storeIcon) storeIcon.classList.add('d-none');
      if (accountIcon) accountIcon.classList.add('d-none');
    } else {
      searchIconElement.classList.remove('d-block');
      searchIconElement.classList.add('d-none');
      if (storeIcon) storeIcon.classList.remove('d-none');
      if (accountIcon) accountIcon.classList.remove('d-none');
    }

    if (isTablet && isPDP) {
      setDisplay(searchRight, 'none');
      setDisplay(logoLeft, 'none');
      setDisplay(logoCenter, 'block');
    } else if (isTablet && yOffset < PAGE_OFFSET && !isHomePage && !isPDP) {
      setDisplay(logoLeft, 'none');
      setDisplay(logoCenter, 'block');
      setDisplay(searchRight, 'none');
      primaryCategory.classList.remove('categories-visible');
    } else if (isTablet && yOffset > PAGE_OFFSET && !isHomePage && !isPDP) {
      setDisplay(logoCenter, 'none');
      setDisplay(logoLeft, 'block');
      setDisplay(searchRight, 'block');
      primaryCategory.classList.add('categories-visible');
    } else if (isMobile && yOffset < PAGE_OFFSET && !isHomePage && !isPDP) {
      setDisplay(logoCenter, 'block');
      setDisplay(logoLeft, 'none');
    }
  }, SCROLL_INTERVAL));

  // On search icon click, scroll down to show search bar
  initSearchIconClick();
};

const initComponents = () => {
  initMobileSearch();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initComponents);
} else {
  initComponents();
}
